import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import MonthlyContractState, {MonthlyContractList} from './states'
import _ from 'lodash'
import axios from 'axios'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<MonthlyContractState> = {
  [mutationType.GET_LISTS](
    state: MonthlyContractState,
    data: MonthlyContractList,
  ): void {
    state.list = data
  },
  [mutationType.CREATE](
    state: MonthlyContractState,
    data: object,
  ): void {
    state.create = data
  },
  [mutationType.UPDATE](
    state: MonthlyContractState,
    data: object,
  ): void {
    state.update = data
  },
  [mutationType.DELETE](
    state: MonthlyContractState,
    data: object,
  ): void {
    state.delete = data
  },
}

export default mutations
